




import { Interfaces, Models, apiService } from "@/core/Export";
import store from "@/store";
import { Component, Vue } from "vue-property-decorator";
@Component({
    components: {}
})
export default class LoginByAccessTokenPage extends Vue {
    accessToken: string;
    customerCode: string;

    constructor() {
        super();
        this.accessToken = "";
        this.customerCode = "";
    }

    created() {
        this.accessToken = this.$route.query.accessToken.toString();
        this.customerCode = this.$route.params.accClientNo;
        this.loginUserByAccessToken();
    }

    async loginUserByAccessToken(): Promise<void> {
        try {
            if (!this.accessToken || !this.customerCode) return;
            await this.appEnv.onCheckApiUrlByCustomerCode(this.customerCode);

            this.appEnv.isBusy = true;
            let result: Interfaces.iServiceRequest = await apiService.validateLoginUserByAccessToken(this.accessToken);
            let call = result.calls[0] as Interfaces.iServiceCall;
            if (call && call.isSuccess) {
                let userInfo: Models.UserInfo = call.callResult.data;
                this.appEnv.login(userInfo);
            } else {
                this.appEnv.showErrorDialog(call.msgs.msgs);
            }
        } catch (error) {
        }
        finally {
            this.appEnv.isBusy = false;
        }
    }

    get appEnv() {
        return store.getters.appEnv;
    }
}
